import Tab from "components/common/Tab/tab";
import Tabs from "components/common/Tab/tabs";
import { useState, useEffect } from "react";
import { useTranslation } from "next-i18next";
import useIsMobile from "states/deviceState";
import { useRouter } from "next/router";
import { useTabTracking } from "lib/analytics/react/hooks";
// 스크롤 이동 함수
export const moveStickyTab = (isMobile: boolean) => {
  const tabsElement = document.querySelector(".common-tab");
  const strategyTabSection = document.querySelector(".strategy-tab-section");
  const strategyTabSectionRect = strategyTabSection?.getBoundingClientRect();
  const tabHeight = tabsElement?.getBoundingClientRect().height;

  if (!strategyTabSectionRect || !tabHeight) return;
  const documentTop = strategyTabSectionRect?.top + window.scrollY;
  const mobileOffset = isMobile ? 0 : 64;
  window.scrollTo({
    top: documentTop - tabHeight - mobileOffset - 1,
    behavior: "smooth",
  });
};
function StrategyTabs({ isMobile }: { isMobile: boolean }) {
  const { t } = useTranslation("strategy");
  const { trackClick } = useTabTracking("strategy_tab_click", [
    "performance",
    "holdings",
  ]);
  const router = useRouter();

  const { type } = router.query;

  return (
    <div
      className={`flex flex-col sticky z-[4] ${
        isMobile ? "top-[0px]" : "top-[60px]"
      }`}
    >
      <Tabs type={"line"}>
        <Tab
          title={t("performance")}
          onClick={() => {
            window.dataLayer.push({
              event: "cStratTabROI",
            });
            trackClick("performance");
            router.replace({ query: { type: "performance" } }, undefined, {
              shallow: true,
            });
            setTimeout(() => {
              moveStickyTab(isMobile);
            }, 10);
          }}
          isActive={type === "performance"}
          type={"line"}
          tabClassNameAdd={"!py-4 st-perf-btn"}
        />
        <Tab
          title={t("holdingsInStrategy")}
          onClick={() => {
            window.dataLayer.push({
              event: "cStratTabComp",
            });
            trackClick("holdings");
            router.replace({ query: { type: "holdings" } }, undefined, {
              shallow: true,
            });
            setTimeout(() => {
              moveStickyTab(isMobile);
            }, 10);
          }}
          isActive={type === "holdings" || !type}
          type={"line"}
          tabClassNameAdd={"!py-4 "}
        />
      </Tabs>
    </div>
  );
}

export default StrategyTabs;
